import React, { useCallback, useEffect, useState } from 'react';
import ProjectsInfo from '../components/ProjectsInfo';
import FilterDrawer from '../components/FilterDrawer';
import dashboardCircle from '@assets/icons/dashboard-circle.png';
import WastageProjectInfo from '../components/WastageProjectInfo';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBUList,
  getFinancialYears,
  getLeaderShipDashboardCounts,
  getLeadershipTableData,
  getProjectList,
  getProjectListWithoutQuarterly,
  getQuarterList,
  getSBGList,
  getSBUList,
} from '../redux/slice';
import * as XLSX from 'xlsx';
import { getLastFinancialYear } from '@utils/helpers';
import { Button, Tooltip } from 'antd';
import { debounce } from 'lodash';
import AdvanceFilter from '../components/AdvanceFilter';
import DashboardFilterSelectors from '../components/DashboardFilterSelectors';
import viewerBgImg from '@assets/images/dsahboard_bg.png';
import backlogIcon from '@assets/icons/backlog.svg';
import ironBarIcon from '@assets/icons/iron_bar.svg';
import valueChainIcon from '@assets/icons/value_chain.svg';
import recycleBinIcon from '@assets/icons/recycle_bin.svg';
import checkIcon from '@assets/icons/check.svg';
import garbageIcon from '@assets/icons/garbage.svg';
import coinsIcon from '@assets/icons/coins.svg';
import warningIcon from '@assets/icons/warning.svg';
import MetricsCard from '../components/MetricsCard';
import AttachedMetricsCard from '../components/AttachedMetricCard';
import activeArrowIcon from '@assets/icons/active_arrow_icon.svg';

const FINANCIAL_YEAR = getLastFinancialYear();

const Dashboard = () => {
  const dispatch = useDispatch();
  const {
    leaderShipDashboardCounts,
    leaderShipDashboardCountsLoading,
    leadershipTableData,
    leadershipTableDataLoading,
    financialYearsData,
    financialYearsLoading,
    quarterListData,
    quarterListLoading,
    sbgListData,
    sbgListLoading,
    sbuListData,
    sbuListLoading,
    buListData,
    buListLoading,
    projectListData,
    projectListLoading,
    projectListDataWithoutQuarterly,
    projectListLoadingWithoutQuarterly,
  } = useSelector((state) => state.viewer);
  const [selectedFilters, setSelectedFilters] = useState([]);

  // const [open, setOpen] = useState(false);
  // const showDrawer = () => {
  //   setOpen(true);
  // };

  // const onClose = () => {
  //   setOpen(false);
  // };

  // const handleFilter = (filterData) => {
  //   const payload = {
  //     filter_array: JSON.stringify(filterData),
  //   };

  //   const selectedData = filterData
  //     .flatMap((item) => item.quarters)
  //     .map((year) => {
  //       const foundQuarter = FINANCIAL_YEARS.flatMap(
  //         (item) => item.quarters,
  //       ).find((y) => y.completeQuarter === year);
  //       return `${foundQuarter.completeQuarter.slice(0, 8)} ${foundQuarter.title.slice(2)}`;
  //     });

  //   setSelectedFilters(selectedData);
  //   dispatch(getLeaderShipDashboardCounts(payload));
  //   dispatch(getLeadershipTableData(payload));
  //   onClose();
  // };

  // useEffect(() => {
  //   const payload = {
  //     filter_array: JSON.stringify([
  //       {
  //         financial_year: FINANCIAL_YEARS.at(-1).completeYear,
  //         quarters: [FINANCIAL_YEARS.at(-1).quarters.at(-2).completeQuarter],
  //       },
  //     ]),
  //   };
  //   dispatch(getLeaderShipDashboardCounts(payload));
  //   dispatch(getLeadershipTableData(payload));
  // }, [dispatch]);

  const [selectedFinancialYear, setSelectedFinancialYear] = useState([]);
  const [selectedQuarters, setSelectedQuarters] = useState([]);
  const [selectedSBG, setSelectedSBG] = useState([]);
  const [selectedSBU, setSelectedSBU] = useState([]);
  const [selectedBU, setSelectedBU] = useState([]);
  const [selectedProjectsCode, setSelectedProjectsCode] = useState([]);
  const [selectedProjectsName, setSelectedProjectsName] = useState([]);
  const [
    selectedProjectsCodeWithoutQuarterly,
    setSelectedProjectsCodeWithoutQuarterly,
  ] = useState([]);
  const [loadProjectNames, setLoadProjectNames] = useState([]);
  const [isInitialDataFetch, setIsInitialDataFetch] = useState(true);
  const [hovered, setHovered] = useState(null);

  const getTransformedFinancialQuarters = () => {
    const financialYears = selectedFinancialYear?.length
      ? selectedFinancialYear
      : [FINANCIAL_YEAR.year];
    const quarters = selectedQuarters?.length
      ? selectedQuarters
      : [FINANCIAL_YEAR.quarter];
    const fyMap = financialYears
      .filter((v) => v !== 'all')
      .map((fy) => ({
        financial_year: fy,
        quarters: [],
      }));

    quarters
      .filter((v) => v !== 'all')
      .forEach((qtr) => {
        const fyKey = qtr.split(' Q')[0];
        const fyEntry = fyMap.find((entry) =>
          entry.financial_year.startsWith(fyKey),
        );

        if (fyEntry) {
          fyEntry.quarters.push(qtr);
        }
      });

    const finalQuarters = fyMap.map((entry) => {
      if (entry.quarters.length === 0) {
        const selectedYear = entry.financial_year.slice(2, 4);
        const nextYear = entry.financial_year.slice(5, 7);

        return {
          ...entry,
          quarters: [
            `FY${selectedYear}-${nextYear} Q1(1-Apr-FY${selectedYear} to 30-Jun-FY${selectedYear})`,
            `FY${selectedYear}-${nextYear} Q2(1-Jul-FY${selectedYear} to 30-Sep-FY${selectedYear})`,
            `FY${selectedYear}-${nextYear} Q3(1-Oct-FY${selectedYear} to 31-Dec-FY${selectedYear})`,
            `FY${selectedYear}-${nextYear} Q4(1-Jan-FY${nextYear} to 31-Mar-FY${nextYear})`,
          ],
        };
      } else {
        return entry;
      }
    });
    return finalQuarters;
  };

  const handleApplyFilter = () => {
    const payload = {};

    if (selectedFinancialYear.filter((v) => v !== 'all').length) {
      payload.filter_array = JSON.stringify(getTransformedFinancialQuarters());
    }

    if (selectedSBG.filter((v) => v !== 'all').length) {
      payload.sbg = selectedSBG.filter((v) => v !== 'all').join(', ');
    }

    if (selectedSBU.filter((v) => v !== 'all').length) {
      payload.sbu = selectedSBU.filter((v) => v !== 'all').join(', ');
    }
    if (selectedBU.filter((v) => v !== 'all').length) {
      payload.bu = selectedBU.filter((v) => v !== 'all').join(', ');
    }

    if (!selectedProjectsName.length) {
      // for project code with quarterly submission
      if (selectedProjectsCode.filter((v) => v !== 'all').length) {
        payload.project_code = [...new Set([...selectedProjectsCode])]
          .filter((v) => v !== 'all')
          .join(', ');
      }
      // for project code without quarterly submission
      if (
        selectedProjectsCodeWithoutQuarterly.filter((v) => v !== 'all').length
      ) {
        payload.project_code_no_quarterly = [
          ...new Set([...selectedProjectsCodeWithoutQuarterly]),
        ]
          .filter((v) => v !== 'all')
          .join(', ');
      }
    } else {
      if (selectedProjectsName.filter((v) => v !== 'all').length) {
        payload.project_code = [...new Set([...selectedProjectsName])]
          .filter((v) => v !== 'all')
          .join(', ');
      }
    }

    if (!selectedFinancialYear.length || !selectedQuarters.length) {
      payload.filter_array = JSON.stringify(getTransformedFinancialQuarters());
    }

    dispatch(getLeaderShipDashboardCounts(payload));
    dispatch(getLeadershipTableData(payload));
    setIsInitialDataFetch(false);
  };

  const restMappedData = (item) => {
    return {
      'Total Projects': item.project_count || null,
      'Quantity Processed - Quarterly': item.tonnage_quarterly,
      'Quantity Processed With BBS': item.tonnage_with_bbs,
      'Quantity Processed Without BBS': item.tonnage_without_bbs,
      'Total Wastage': item.total_wastage,
      'A1. Wastage': item.wastage_with_system,
      'A2. Wastage': item.wastage_with_actual,
      'B. Wastage': item.wastage_without_bbs,
      'Tool Adoption': item.adoption,
      'Wastage (in MT)': item.wastage_in_mt,
      // 'Actual Wastage': item.actual_wastage,
      // 'Optimal Wastage': item.optimal_wastage,
      'Budgeted Wastage': item.budgeted_wastage,
      'Savings/Overruns Wastage (in %)': item.savings_per,
      'Savings/Overruns Wastage (In Ton)': item.savings_in_ton,
      'Savings/Overruns Wastage (In Lakh)': item.savings_in_lakh,
    };
  };

  const getTransformedProjectsData = (data = []) => {
    let flattenedData = [];

    data.forEach((item) => {
      const currentSBG = item.name;

      // Add top-level SBG row only once
      flattenedData.push({
        SBG: currentSBG,
        SBU: '',
        BU: '',
        'Project Code': '',
        ...restMappedData(item),
      });

      if (item.SBU) {
        item.SBU.forEach((sbuItem) => {
          flattenedData.push({
            SBG: currentSBG,
            SBU: sbuItem.name,
            BU: '',
            'Project Code': '',
            ...restMappedData(sbuItem),
          });

          if (sbuItem.BU) {
            sbuItem.BU.forEach((buItem) => {
              flattenedData.push({
                SBG: currentSBG,
                SBU: sbuItem.name,
                BU: buItem.name,
                'Project Code': '',
                ...restMappedData(buItem),
              });

              if (buItem.projects) {
                buItem.projects.forEach((project) => {
                  flattenedData.push({
                    SBG: currentSBG,
                    SBU: sbuItem.name,
                    BU: buItem.name,
                    'Project Code': project.code,
                    ...restMappedData(project),
                  });
                });
              }
            });
          }
        });
      }
    });

    return flattenedData;
  };

  const handleDownloadExcelSheet = () => {
    if (!leadershipTableData || leadershipTableData.length === 0) {
      alert('No data available to download.');
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(
      getTransformedProjectsData(leadershipTableData),
    );

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Wastage Information');
    XLSX.writeFile(workbook, `Wastage Information.xlsx`);
  };

  const getAllInitialData = useCallback(() => {
    dispatch(getFinancialYears()).then(
      (res) => setSelectedFinancialYear([]),
      setSelectedQuarters([]),
    );

    const filter_array = JSON.stringify([
      {
        financial_year: FINANCIAL_YEAR.year,
        quarters: [FINANCIAL_YEAR.quarter],
      },
    ]);

    dispatch(getSBGList({ filter_array })).then((res) => setSelectedSBG([]));
    dispatch(getSBUList({ filter_array })).then((res) => setSelectedSBU([]));
    dispatch(getBUList({ filter_array })).then((res) => setSelectedBU([]));
    dispatch(getProjectList({ filter_array })).then((res) => {
      setSelectedProjectsName([]);
      setSelectedProjectsCode([]);
    });
    dispatch(getProjectListWithoutQuarterly({ filter_array })).then((res) => {
      setSelectedProjectsName([]);
      setSelectedProjectsCodeWithoutQuarterly([]);
    });

    const payload = {
      filter_array,
    };
    dispatch(getLeaderShipDashboardCounts(payload));
    dispatch(getLeadershipTableData(payload));
    setIsInitialDataFetch(true);
  }, [dispatch]);

  useEffect(() => {
    getAllInitialData();
  }, [getAllInitialData]);

  useEffect(() => {
    if (selectedFinancialYear.length) {
      dispatch(
        getQuarterList({
          financialYear: selectedFinancialYear
            .filter((v) => v !== 'all')
            .map((y) => {
              const selectedYear = y.slice(2, 4);
              const nextYear = y.slice(5, 7);

              return `${selectedYear}-${nextYear}`;
            })
            .join(','),
        }),
      );
    }
  }, [selectedFinancialYear, dispatch]);

  // ...... on financial year and quarter change fetching all list apis
  useEffect(() => {
    if (
      selectedFinancialYear.filter((v) => v !== 'all').length &&
      selectedQuarters.filter((v) => v !== 'all').length
    ) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
      };
      dispatch(getSBGList(payload));
      dispatch(getProjectList(payload));
      dispatch(getProjectListWithoutQuarterly(payload));
      dispatch(getSBUList(payload));
      dispatch(getBUList(payload));
      setSelectedSBG([]);
      setSelectedSBU([]);
      setSelectedBU([]);
      setSelectedProjectsCode([]);
      setSelectedProjectsCodeWithoutQuarterly([]);
      setSelectedProjectsName([]);
    }
  }, [selectedQuarters, dispatch]);

  useEffect(() => {
    if (selectedSBG.filter((v) => v !== 'all').length) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
        sbg_array: JSON.stringify(selectedSBG),
      };
      dispatch(getSBUList(payload));
      dispatch(getBUList(payload));
      dispatch(getProjectList(payload));
      dispatch(getProjectListWithoutQuarterly(payload));
      setSelectedSBU([]);
      setSelectedBU([]);
      setSelectedProjectsCode([]);
      setSelectedProjectsCodeWithoutQuarterly([]);
      setSelectedProjectsName([]);
    }
  }, [selectedSBG, dispatch]);

  useEffect(() => {
    if (
      // selectedSBG.filter((v) => v !== 'all').length &&
      selectedSBU.filter((v) => v !== 'all').length
    ) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
        sbg_array: JSON.stringify(selectedSBG),
        sbu_array: JSON.stringify(selectedSBU),
      };
      dispatch(getBUList(payload));
      dispatch(getProjectList(payload));
      dispatch(getProjectListWithoutQuarterly(payload));
      setSelectedBU([]);
      setSelectedProjectsCode([]);
      setSelectedProjectsCodeWithoutQuarterly([]);
      setSelectedProjectsName([]);
    }
  }, [dispatch, selectedSBU]);

  useEffect(() => {
    if (
      // selectedSBG.filter((v) => v !== 'all').length &&
      // selectedSBU.filter((v) => v !== 'all').length &&
      selectedBU.filter((v) => v !== 'all').length
    ) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
        sbg_array: JSON.stringify(selectedSBG),
        sbu_array: JSON.stringify(selectedSBU),
        bu_array: JSON.stringify(selectedBU),
      };
      dispatch(getProjectList(payload));
      dispatch(getProjectListWithoutQuarterly(payload));
      setSelectedProjectsCode([]);
      setSelectedProjectsCodeWithoutQuarterly([]);
      setSelectedProjectsName([]);
    }
  }, [dispatch, selectedBU]);

  // ...... on project code change fetching all list apis
  useEffect(() => {
    if (
      selectedProjectsCode.filter((v) => v !== 'all').length ||
      selectedProjectsCodeWithoutQuarterly.filter((v) => v !== 'all').length
    ) {
      setLoadProjectNames([
        ...projectListData.filter((p) =>
          selectedProjectsCode.includes(p.project_code),
        ),
        ...projectListDataWithoutQuarterly.filter((p) =>
          selectedProjectsCodeWithoutQuarterly.includes(p.project_code),
        ),
      ]);
      setSelectedProjectsName([]);
    }
  }, [
    selectedProjectsCode,
    projectListData,
    selectedProjectsCodeWithoutQuarterly,
    projectListDataWithoutQuarterly,
  ]);

  const COUNTS = [
    {
      counts: leaderShipDashboardCounts?.total_projects || 0,
      countsSubLabel: 'Total Projects',
      label: 'in bbs optimization tool',
      countColor: '#1C4E9D',
      icon: backlogIcon,
      bigText: true,
      bgColor: '#b1cffe',
      hasOuterLayer: true,
      outerLayerBg: '#FFFFFF',
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#ffffff',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
    {
      counts: Number(
        leaderShipDashboardCounts?.total_quantity_processed || 0,
      ).toFixed(2),
      label: 'With/without bbs Optimization tool',
      subLabel: '(in MT)',
      countColor: '#9747FF',
      countsSubLabel: 'Total quantity processed',
      icon: ironBarIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
    {
      counts: `${Number(
        leaderShipDashboardCounts?.optimised_wastage || 0,
      ).toFixed(2)} %`,
      label: 'With/without bbs Optimization tool',
      subLabel: '( % )',
      countColor: '#12B76A',
      icon: valueChainIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      countsSubLabel: 'Total wastage',
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[84px] right-1 -top-1 w-20',
      onHoverContent: null,
    },

    {
      counts: leaderShipDashboardCounts?.total_bbs_created || 0,
      label: 'BBS Optimization usage',
      countsSubLabel: 'Projects with',
      countColor: '#FFFFFF',
      icon: checkIcon,
      bigText: true,
      bgColor: '#003B97',
      hasOuterLayer: true,
      outerLayerBg: '#99B1D5',
      labelColor: '#FFFFFF',
      countsSubLabelColor: '#ffffff7f',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      hoverIcon: activeArrowIcon,
      onHoverContent: [
        {
          counts: leaderShipDashboardCounts?.total_projects_with_bbs || 0,
          label: '(quantity, wastage)',
          countsSubLabel: 'Projects submitted complete quarterly input',
          countColor: '#61C911',
          icon: recycleBinIcon,
          bigText: false,
          bgColor: '#FFFFFF',
          hasOuterLayer: false,
          labelColor: '#1C4E9D',
          countsSubLabelColor: '#1C4E9DB2',
          iconClasses: 'h-16 -right-2.5 top-0 w-16',
        },
        {
          counts: leaderShipDashboardCounts?.total_projects_without_bbs || 0,
          countsSubLabel: 'Projects not submitted complete quarterly input',
          label: '(quantity, wastage)',
          countColor: '#B64439',
          icon: warningIcon,
          bigText: false,
          bgColor: '#FFFFFF',
          hasOuterLayer: false,
          labelColor: '#1C4E9D',
          countsSubLabelColor: '#1C4E9DB2',
          iconClasses: 'h-16 -right-2 top-0 w-16',
        },
      ],
    },
    {
      counts: Number(leaderShipDashboardCounts?.total_savings || 0).toFixed(1),
      label: 'SAVINGS WRT BUDGETED WASTAGE',
      countsSubLabel: 'Total in Rs Lakhs',
      countColor: '#DC6701',
      icon: coinsIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3 -top-3 w-28',
      onHoverContent: null,
    },
    {
      counts: `${Number(
        leaderShipDashboardCounts?.savings_wrt_budgeted_wastage || 0,
      ).toFixed(2)} %`,
      countsSubLabel: 'Percentage',
      label: 'SAVINGS WRT BUDGETED WASTAGE',
      countColor: '#FF8316',
      icon: garbageIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
  ];

  const SMALL_CARDS = [
    {
      counts: leaderShipDashboardCounts?.total_projects_with_bbs || 0,
      label: '(quantity, wastage)',
      countsSubLabel: 'Projects submitted for quarterly input',
      countColor: '#61C911',
      icon: recycleBinIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-16 -right-2.5 top-0 w-16',
      onHoverContent: null,
    },
    {
      counts: leaderShipDashboardCounts?.total_projects_without_bbs || 0,
      countsSubLabel: 'Projects not submitted for quarterly input',
      label: '(quantity, wastage)',
      countColor: '#B64439',
      icon: warningIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-16 -right-2 top-0 w-16',
      onHoverContent: null,
    },
  ];

  const debouncedSearch = useCallback(
    debounce((query, results) => {
      dispatch(results({ search: query }));
    }, 500),
    [],
  );

  const handleSearch = (val, results) => {
    debouncedSearch(val, results);
  };

  const handleChange = (val, setVals, data) => {
    const allSelected = val.includes('all');
    const isSelectingAll = val.at(-1) === 'all';
    if (val.length === 0) {
      setVals([]);
      return;
    }
    if (isSelectingAll) {
      setVals(['all', ...data]);
    } else if (allSelected && val.length - 1 < data.length) {
      setVals(val.filter((v) => v !== 'all'));
    } else {
      setVals(val);
    }
  };

  return (
    <div className="relative z-20 flex w-full gap-3 pl-0 pr-4 md:pr-6 xl:pr-3 2xl:pl-3 2xl:pr-6 py-5 bg-[#F8F8F8] min-h-screen">
      <img
        src={viewerBgImg}
        alt="viewer bg img"
        className="fixed top-0 left-0 w-full h-[381px] 2xl:h-auto -z-10"
      />

      {/* left section */}
      <div className="w-full md:w-[70%] lg:w-[78%] relative flex flex-col mt-6 lg:mt-8 animate-moveFromTop">
        {/* excel sheet dpwnload button */}
        <Button
          disabled={!leadershipTableData.length}
          onClick={handleDownloadExcelSheet}
          className="font-['SF-Pro-Text-Regular, sans-serif'] hover:!bg-white hover:!text-[#1C4E9D] !bg-transparent -top-6  lg:-top-8 border border-white rounded-[4px] text-xs absolute right-0 !text-white"
        >
          Download
        </Button>

        <div className="mx-4 lg:mx-8">
          <div className="flex gap-2 items-center">
            <h1 className="text-xl text-white font-segoe-ui">
              Metric Overview
            </h1>
            <Tooltip
              title={
                'Projects include System generated wastage BBS, Actual wastage BBS, Wastage without BBS - in the selected quarter'
              }
              overlayInnerStyle={{ fontSize: '10px' }}
            >
              <img
                className="w-3.5 h-3.5 cursor-pointer flex"
                src={dashboardCircle}
                alt="Info Icon"
              />
            </Tooltip>
          </div>
          {isInitialDataFetch && (
            <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-xs text-white opacity-70">
              Data from the Last Quarter
            </p>
          )}
        </div>

        {/* cards */}
        <div className="justify-center mt-5 mb-8 w-full lg:flex ms-4 lg:ms-8 me-0 lg:me-5">
          <div className="flex flex-col gap-2.5 lg:w-[78%]">
            <div className="grid grid-cols-3 gap-2.5 w-full">
              {COUNTS.slice(0, 3).map((count, i) => {
                return (
                  <MetricsCard
                    id={i + 1}
                    key={count.countColor}
                    data={count}
                    loading={leaderShipDashboardCountsLoading}
                    setHovered={setHovered}
                    hovered={hovered}
                  />
                );
              })}
            </div>
            <div
              className={`grid gap-2.5 transition-all duration-300 ease-in-out ${hovered === 4 ? '-ml-10 w-[110%]' : 'w-full'}`}
              style={{
                gridTemplateColumns:
                  hovered === 4 ? '1.3fr 1fr 1fr' : '1fr 1fr 1fr',
              }}
            >
              {COUNTS.slice(3).map((count, i) => (
                <MetricsCard
                  id={i + 4}
                  key={count.countColor}
                  data={count}
                  loading={leaderShipDashboardCountsLoading}
                  setHovered={setHovered}
                  hovered={hovered}
                />
              ))}
            </div>
          </div>
          {/* <div className="grid grid-cols-2 lg:grid-cols-1 ml-0 lg:ml-2.5 w-full mt-2.5 lg:mt-0 lg:w-[15%]">
            {SMALL_CARDS.map((count, i) => {
              return (
                <AttachedMetricsCard
                  key={count.countColor}
                  isFirst={i === 0}
                  isLast={SMALL_CARDS.length - 1 === i}
                  data={count}
                  loading={leaderShipDashboardCountsLoading}
                />
              );
            })}
          </div> */}
        </div>
        {/* <div className="mx-8 grid grid-cols-4 gap-2.5 mt-5 mb-8">
            {COUNTS.map((count) => {
              return (
                <MetricsCard
                  key={count.label}
                  data={count}
                  loading={leaderShipDashboardCountsLoading}
                />
              );
            })}
          </div> */}

        {/* project wastage information */}
        <div className="px-2 py-2 ml-3 bg-white rounded-xl lg:px-5">
          <div className="flex gap-2 items-center">
            <h1 className="text-xl font-segoe-ui text-[#1C4E9D]">Data</h1>
            <Tooltip
              title={'Data for projects with complete wastage information'}
              overlayInnerStyle={{ fontSize: '10px' }}
            >
              <img
                className="w-3.5 h-3.5 cursor-pointer flex"
                src={dashboardCircle}
                alt="Info Icon"
              />
            </Tooltip>
          </div>

          <WastageProjectInfo
            loading={leadershipTableDataLoading}
            dataSource={leadershipTableData}
          />
        </div>
      </div>

      {/* right section */}
      <AdvanceFilter
        loadingData={
          leaderShipDashboardCountsLoading || leadershipTableDataLoading
        }
        resetFilter={getAllInitialData}
        applyFilter={handleApplyFilter}
        filterForm={
          <DashboardFilterSelectors
            financialYearsLoading={financialYearsLoading}
            selectedFinancialYear={selectedFinancialYear}
            handleSearch={handleSearch}
            getFinancialYears={getFinancialYears}
            financialYearsData={financialYearsData}
            handleChange={handleChange}
            setSelectedFinancialYear={setSelectedFinancialYear}
            quarterListLoading={quarterListLoading}
            selectedQuarters={selectedQuarters}
            quarterListData={quarterListData}
            setSelectedQuarters={setSelectedQuarters}
            sbgListLoading={sbgListLoading}
            selectedSBG={selectedSBG}
            sbgListData={sbgListData}
            setSelectedSBG={setSelectedSBG}
            sbuListLoading={sbuListLoading}
            getSBUList={getSBUList}
            selectedSBU={selectedSBU}
            sbuListData={sbuListData}
            setSelectedSBU={setSelectedSBU}
            buListLoading={buListLoading}
            selectedBU={selectedBU}
            getBUList={getBUList}
            buListData={buListData}
            setSelectedBU={setSelectedBU}
            projectListLoading={projectListLoading}
            selectedProjectsCode={selectedProjectsCode}
            projectListData={projectListData}
            setSelectedProjectsCode={setSelectedProjectsCode}
            selectedProjectsName={selectedProjectsName}
            getProjectList={getProjectList}
            loadProjectNames={loadProjectNames}
            setSelectedProjectsName={setSelectedProjectsName}
            projectListDataWithoutQuarterly={projectListDataWithoutQuarterly}
            projectListLoadingWithoutQuarterly={
              projectListLoadingWithoutQuarterly
            }
            selectedProjectsCodeWithoutQuarterly={
              selectedProjectsCodeWithoutQuarterly
            }
            setSelectedProjectsCodeWithoutQuarterly={
              setSelectedProjectsCodeWithoutQuarterly
            }
            getProjectListWithoutQuarterly={getProjectListWithoutQuarterly}
          />
        }
      />
    </div>
  );
};

export default Dashboard;
